import {useState} from "react";
import {ModalSize, SimpleModal} from "../../SimpleModal";
import {Button} from "../../Button";
import Form, {FormInitValuesType} from "../../Form";
import {Tab, Tabs} from "../../Tabs/Tabs";
import * as S from './styles'

import FeedBackImage from '../../../assets/images/ab_feedback_image.png'
import {FormattedMessage, useIntl} from "react-intl";


const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
const validateEmail = value => {
    return !!(value && value.match(isValidEmail));
}

const initValues: FormInitValuesType = {
    name: {value: '', validationCheck: (value) => value !== ''},
    email: {value: '', validationCheck: validateEmail},
    message: {value: '', validationCheck: value => value !== ''}
}

export const Feedback = () => {
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const closeModal = () => setShow(false);

    const intl = useIntl();

    return (
        <S.Container>
            <S.Content>
                <S.TextBlock>
                    <S.Title>
                        <FormattedMessage id="aboutFeedbackTitle"/>
                    </S.Title>
                    <S.Text>
                        <FormattedMessage id="aboutFeedbackText1"/>
                    </S.Text>
                    <Button onClick={showModal}><FormattedMessage id="aboutFeedbackButton1"/></Button>
                </S.TextBlock>
                <S.ImageBlock>
                    <S.Image src={FeedBackImage}/>
                </S.ImageBlock>
            </S.Content>
            <SimpleModal show={show} close={closeModal} modalSize={ModalSize.medium}>
                <S.ModalBody>
                    <S.Title><FormattedMessage id="aboutFeedbackModalTitle"/></S.Title>

                    <Tabs activeKey={"tab1"}>
                        <Tab label={"Предложения улучшения"} name={"tab1"}>
                            <Form initValues={initValues} apply={data => alert(JSON.stringify(data))}>
                                {
                                    ({data, setValue, isValid, onSubmit}) => {
                                        return (
                                            <div style={{textAlign: 'center'}}>
                                                <Form.Input
                                                    name={'name'}
                                                    placeholder={intl.formatMessage({id: 'aboutFeedbackModalFIO'})}
                                                    data={data}
                                                    setValue={setValue}
                                                    isValid={isValid['name']}
                                                    hint={intl.formatMessage({id: 'aboutFeedbackModalFIOHint'})}
                                                />

                                                <Form.Input
                                                    name={'email'}
                                                    placeholder={intl.formatMessage({id: 'aboutFeedbackModalMail'})}
                                                    data={data}
                                                    setValue={setValue}
                                                    isValid={isValid['email']}
                                                    hint={intl.formatMessage({id: 'aboutFeedbackModalMailHint'})}
                                                />

                                                <Form.TextArea
                                                    name={'message'}
                                                    placeholder={intl.formatMessage({id: 'aboutFeedbackModalMessage'})}
                                                    data={data}
                                                    setValue={setValue}
                                                    isValid={isValid['message']}
                                                />

                                                <Form.Submit onClick={onSubmit}>ОТПРАВИТЬ ЗАЯВКУ</Form.Submit>
                                            </div>
                                        )
                                    }
                                }
                            </Form>
                        </Tab>
                        <Tab label={"Ошибка"} name={"tab2"}>tab2</Tab>
                        <Tab label={"Другое"} name={"tab3"}>tab3</Tab>
                    </Tabs>
                </S.ModalBody>
            </SimpleModal>
        </S.Container>
    )
}